export default class ResetClick {
	constructor(elements, callback) {
		this.excludedElements = Array.isArray(elements) ? elements : [elements];

		document.addEventListener('click', (e) => {
			if (!this.isInsideExcludedElements(e.target)) {
				callback();
			}
		})
	}

	isInsideExcludedElements(target) {
		return this.excludedElements.some(element => element.contains(target));
	}
}
